import { render, staticRenderFns } from "./outboundreport_main.vue?vue&type=template&id=1d2653e4&scoped=true"
import script from "./outboundreport_main.vue?vue&type=script&lang=js"
export * from "./outboundreport_main.vue?vue&type=script&lang=js"
import style0 from "./outboundreport_main.vue?vue&type=style&index=0&id=1d2653e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2653e4",
  null
  
)

export default component.exports